<div class="hub-content-background" *ngIf="!loadingTheme">
    <div class="hub-navbar" [ngClass]="{shadow: showShadow}" *ngIf="showNavBar">
        <div class="nav-background">
            <div style="margin-left:8px;" class="hub-navlogo">
                <img src='../../../../../assets/hubtiger_logo_full_background.png'/>
                <div class="custom_logo"></div>
            </div>            
            <!-- <div class="store-badge">
                    <div class="apple-ios-badge" *ngIf="platform==='iOS'">
                        <a href="https://apps.apple.com/za/app/hubtiger-bike-management/id1370993581?mt=8">
                            <img src='../../../../assets/app-store-badge.png'/>
                        </a>
                    </div>
                    <div class="google-play-badge" *ngIf="platform==='Android'">
                        <a href="https://play.google.com/store/apps/details?id=com.hubtiger.hubtiger&hl=en_ZA&pcampaignid=pcampaignidMKT-Other-global-all-co-prtnr-py-PartBadge-Mar2515-1">
                            <img src='../../../../assets/google-play-badge.png'/>
                        </a>
                    </div>
            </div> -->
        </div>
    </div>    
    <div class="hub-content-no-menu">
        <div>
            <router-outlet></router-outlet>
        </div>
    </div>
</div>
<p-toast position="bottom-right" styleClass="hubtiger-toast"></p-toast>
<link *ngIf="customCSSURL" rel="stylesheet" [attr.href]="customCSSURL"> 